<template>
    <div class="container">
        <div class="box">
            <h3 class="title reveal-bottom">
                {{ $t("ep.t2") }}
            </h3>
            <p class="text reveal-bottom">
                {{ $t("ep.c2") }}
            </p>
            <div class="img-w reveal-bottom">
                <img
                    style="width:1200px;"
                    :src="
                        lang === 'en_US'
                            ? require('@/assets/img_svg/enterprise_img_3_en.png')
                            : require('@/assets/img_svg/enterprise_img_3_cn.png')
                    "
                    alt="svg"
                />
            </div>
            <div class="box-wrap">
                <div class="box-item reveal-bottom">
                    <h3>{{ $t("ep.kt") }}</h3>
                    <p
                        :style="
                            lang === 'en_US'
                                ? 'font-size:14px;line-height:20px'
                                : ''
                        "
                    >
                        {{ $t("ep.kc") }}
                    </p>
                </div>
                <div class="box-item reveal-bottom">
                    <h3>{{ $t("ep.kt1") }}</h3>
                    <p
                        :style="
                            lang === 'en_US'
                                ? 'font-size:14px;line-height:20px'
                                : ''
                        "
                    >
                        {{ $t("ep.kc1") }}
                    </p>
                </div>
                <div class="box-item reveal-bottom">
                    <h3>{{ $t("ep.kt2") }}</h3>
                    <p
                        :style="
                            lang === 'en_US'
                                ? 'font-size:14px;line-height:20px'
                                : ''
                        "
                    >
                        {{ $t("ep.kc2") }}
                    </p>
                </div>
                <div class="box-item reveal-bottom">
                    <h3>{{ $t("ep.kt3") }}</h3>
                    <p
                        :style="
                            lang === 'en_US'
                                ? 'font-size:14px;line-height:20px'
                                : ''
                        "
                    >
                        {{ $t("ep.kc3") }}
                    </p>
                </div>
                <div class="box-item reveal-bottom">
                    <h3>{{ $t("ep.kt4") }}</h3>
                    <p
                        :style="
                            lang === 'en_US'
                                ? 'font-size:14px;line-height:20px'
                                : ''
                        "
                    >
                        {{ $t("ep.kc4") }}
                    </p>
                </div>
                <div class="box-item reveal-bottom">
                    <h3>{{ $t("ep.kt5") }}</h3>
                    <p
                        :style="
                            lang === 'en_US'
                                ? 'font-size:14px;line-height:20px'
                                : ''
                        "
                    >
                        {{ $t("ep.kc5") }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            lang: localStorage.getItem("lang"),
        };
    },
    mounted() {
        this.$bus.$on("lang", (lang) => {
            this.lang = lang;
        });
    },
};
</script>
<style scoped>
.container {
    overflow: hidden;
    background-color: #fff;
}
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
.title {
    font-size: 44px;
    color: #000000;
    letter-spacing: 0;
    line-height: 66px;
    margin-top: 150px;
}
.text {
    font-size: 22px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 44px;
    margin-top: 41px;
}
.img {
    width: 1180px;
    height: 363px;
    margin-bottom: 86px;
}
.img-w {
    width: 1180px;
    height: 363px;
    margin-top: 95px;
    margin-bottom: 86px;
}
.box-wrap {
    display: flex;
    height: 473px;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 150px;
    padding-top: 60px;
}
.box-item {
    width: 374px;
    height: 215px;
    background: #f8f8f8;
    padding: 33px 30px;
    box-sizing: border-box;
}
.box-item > h3 {
    font-size: 18px;
    color: #000000;
    line-height: 27px;
    margin-bottom: 12px;
}
.box-item > p {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 27px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Enterprise/Content2.vue